const $ = window.jQuery;

export default class AboutUs {
    constructor() {
        $(document).on('click', '#frise-container .date-link', (e) => {
            e.preventDefault();
            this.frise(e);
        });
    }

    frise(e){
        let target = $(e.currentTarget);
        if(!target.hasClass('active')){
            $('#frise-container .date-link').removeClass('active');
            target.addClass('active');
            let id = target.data('date');
            $('#after-frise .date-detail').removeClass('active');
            $('#after-frise .date-detail[data-date=' + id + ']').addClass('active');
        }
    }

}
